import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ContentLayout from '../../../layout/ContentLayout';
import { Container } from '../../../components/content';
import CategoryForm from '../../../components/products/CategoryForm';
import categoryApi from '../../../api/category-api';
import styles from '../../../styles/mobileInfoPage.module.scss';

export default function DodajKategoriju() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (payload) => {
    setSaving(true);
    const { success, message } = await categoryApi.create(payload);
    if (success) {
      toast.success('Kategorija je uspešno kreirana');
      navigate('/proizvodi?tab=kategorije');
    } else {
      toast.error(message || 'Greška pri kreiranju kategorije');
    }
    setSaving(false);
  };

  return (
    <Container>
      <Link to="/proizvodi?tab=kategorije" className="link_btn" style={{ marginBottom: '12px' }}>
        <img alt="back" src="/assets/icons/chevron.svg" />
        <span>Nazad</span>
      </Link>

      <ContentLayout pt={true}>
        <h2 className={styles.pageTitle} style={{ marginBottom: '32px' }}>
          Nova kategorija
        </h2>
        <CategoryForm mode="create" saving={saving} onSubmit={handleSubmit} />
      </ContentLayout>
    </Container>
  );
}
